<template>
    <section class="app-main">
        <transition name="fade-transform" mode="out-in">
            <keep-alive :include="cachedViews">
                <router-view :key="key"/>
            </keep-alive>
        </transition>
    </section>
</template>

<script>
export default {
    name: 'AppMain',
    computed: {
        cachedViews(){
            return this.$store.state.tags.cachedViews
        },
        key() {
            return this.$route.path
        }
    }
}
</script>

<style scoped>
.app-main {
    width: 100%;
    height: 95.5%;
    position: relative;
    overflow-y: hidden;
}
</style>


// WEBPACK FOOTER //
// src/layout/components/AppMain.vue